<ng-container *transloco="let t; read: 'analysis-config-selector'">
  @if (!loading) {
    <mat-form-field>
      <input
        type="text"
        matInput
        #configInput
        [matAutocomplete]="configCompleter"
        name="configurationId"
        [placeholder]="t('configuration')"
        required
        (keyup)="filterConfigurations($event)"
        [formControl]="configSelectControl"
      />
      @if (loading) {
        <mat-spinner matSuffix diameter="24"></mat-spinner>
      }
      <mat-autocomplete
        [autoActiveFirstOption]="true"
        #configCompleter="matAutocomplete"
        [displayWith]="displayConfiguration"
        (optionSelected)="onConfigSelected($event)"
      >
        @for (language of languages; track language) {
          <mat-optgroup [label]="language">
            @for (config of filteredConfigurations[language]; track config) {
              <mat-option
                [value]="config"
                [disabled]="!!configDisabled(config)"
                [matTooltip]="configTooltip(config)"
              >
                <div class="config-selector-option__container">
                  <app-configuration-pill
                    [templateType]="getTemplateType(config)"
                    [tooltip]="config.language_name"
                  ></app-configuration-pill>
                  <span class="config-selector-option__text">
                    {{ config.name }}
                  </span>
                  @if (hasEieTag(config)) {
                    <span [matTooltip]="getEieTagTooltipText(config)">
                      <xi-icon
                        class="config-selector-option__icon"
                        icon="app_textAnalytics"
                      ></xi-icon>
                    </span>
                  }
                </div>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
      <mat-error>{{ t('field-required') }}</mat-error>
      @if (!disabled) {
        <mat-hint [innerHtml]="t('configuration-selection-hint')"></mat-hint>
      }
      @if (disabled) {
        <mat-hint>{{ t('configuration-change-disabled') }}</mat-hint>
      }
    </mat-form-field>
  } @else {
    <xi-animation [width]="100" [height]="100" [loop]="true" animation="cx_loader"></xi-animation>
  }
  @if (configRouteSelected) {
    <mat-form-field class="route-language-selector">
      <mat-label>{{ t('route-language') }}</mat-label>
      <mat-select
        [(ngModel)]="selectedRouteLanguage"
        [formControl]="routeLanguageControl"
        (selectionChange)="onRouteLangChanged($event)"
      >
        @for (language of selectedRouteLanguages; track language) {
          <mat-option [value]="language">
            {{ language }}
          </mat-option>
        }
      </mat-select>
      <mat-error>{{ t('field-required') }}</mat-error>
    </mat-form-field>
  }
</ng-container>
